export const Config = {
  MAX_QUBIT_COUNT: 16,
} as const
